import { BaseColorType } from '@evrekadev/evreka-ui-components'
import React from 'react'

export type AIStarterProps = {
  title: string
  description: string
  action: any
  data: any
}

export enum AIActions {
  // Actions
  CLIENT_SUMMARY = 'CLIENT_SUMMARY',
  VEHICLE_PERFORMANCE = 'VEHICLE_PERFORMANCE',
  INVENTORY_ANALYSIS = 'INVENTORY_ANALYSIS',
  EMPLOYEE_PERFORMANCE = 'EMPLOYEE_PERFORMANCE',
  WASTE_ANALYSIS = 'REGION_ANALYSIS',
  ANOMALY_ANALYSIS = 'ANOMALY_ANALYSIS',
  EXECUTIVE_SUMMARY = 'EXECUTIVE_SUMMARY',
  ASSIGNMENT_ANALYSIS = 'ASSIGNMENT_ANALYSIS',
  // Assistants
  SUSTAINABILITY_ASSISTANT = 'SUSTAINABILITY_ASSISTANT',
  TEXTILE_ASSISTANT = 'TEXTILE_ASSISTANT',
  // Feedback
  FEEDBACK = 'FEEDBACK',
}

export type ActionType = {
  title: string
  description: string
  action: AIActions
  icon: React.ReactNode
  dataComponent?: React.ReactNode
  assistantId?: string
  color?: BaseColorType
}
